import { ColDef, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import { DEFAULT_FILTER_PARAMS } from "../defaultOptions";
import { getDateString } from "../../../utils/date-utils";

export const getDateColDef = (field: string): ColDef => {
	return {
	type: "dateColumn",
	filter: "agDateColumnFilter",
		valueGetter: (params: ValueGetterParams) => {
			if (!params.data) return null;
			const value = params.data[field];
			if (!value) return null;
			const d: Date = new Date(value);
			return d;
		},
	valueFormatter: (params: ValueFormatterParams) => {
		if (!params.value) return "";
			return getDateString(params.value, true);
	},
	width: 220,
	minWidth: 220,
	filterParams: {
		...DEFAULT_FILTER_PARAMS,
		filterOptions: [
			"equals",
			"notEqual",
			"lessThan",
			"lessThanOrEqual",
			"greaterThan",
			"greaterThanOrEqual",
			"inRange",
			"empty",
		],
	},
};
};
